import { getServerSideSitemapLegacy } from 'next-sitemap';

import type { GetServerSideProps, NextPage } from 'next';

import { getStatusBoardSitemapFields } from '@/shared/config/sitemap';

const SitemapPage: NextPage = () => {
  return null;
};

export default SitemapPage;

export const getServerSideProps: GetServerSideProps = async ctx => {
  return getServerSideSitemapLegacy(ctx, getStatusBoardSitemapFields());
};
